// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Jgrx","left":"styles_left__1qUg_"};